import { render, staticRenderFns } from "./Respondents.vue?vue&type=template&id=19977efb&scoped=true"
import script from "./Respondents.vue?vue&type=script&lang=js"
export * from "./Respondents.vue?vue&type=script&lang=js"
import style0 from "./Respondents.vue?vue&type=style&index=0&id=19977efb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19977efb",
  null
  
)

export default component.exports